import { loader } from 'graphql.macro';
import { createDataSource } from 'utils/gql-datasource';
const dsGetMessages = loader('./getEasyPayMessages.gql');
export const dsEasyPayMessages = createDataSource(dsGetMessages, {});
